export default {
  it: {
    booking_request: {
      save_and_continue: 'Salva e continua',
      owner: 'Proprietario',
      boat: 'Imbarcazione',
      booking: 'Prenotazione',
      summary: 'Riepilogo',
      request_sent: 'Richiesta inviata',
      request_sent_message: 'La tua richiesta di prenotazione è stata inviata correttamente.',
      request_sent_description: "A breve, riceverai un'email con il riepilogo della tua richiesta, se intendi effettuare la prenotazione clicca sul link presente nella email.",
      from: 'Dal',
      to: 'al',
      quote: 'Preventivo',
      quote_disclaimer: "L'importo è indicativo e non include gli eventuali costi dei servizi aggiuntivi.",
      accept: 'Accetto',
      privacy_label: "l'informativa sul trattamento dei dati personali trasmessi",
      rules_label: 'il regolamento del porto',
      quote_message: "La richiesta sarà inoltrata ai nostri uffici e sarà presa in carico per la verifica, nel caso la richiesta venga accettata, riceverai un'email di conferma.", // Potrai cancellare la tua prenotazione in qualsiasi momento seguendo le istruzioni riportate in essa.",
      send_request: 'Invia la richiesta',
      accept_privacy_and_port_regulations: 'Accetta la privacy e il regolamento del porto'
    }
  },
  en: {
    booking_request: {
      save_and_continue: 'Save and continue',
      owner: 'Owner',
      boat: 'Boat',
      booking: 'Booking',
      summary: 'Summary',
      request_sent: 'Request sent',
      request_sent_message: 'Your request was correctly sent.',
      request_sent_description: 'Shortly you should receive an email with the recap of your request. If you decide to continue with your booking, click on the link that you will find in your email',
      from: 'From',
      to: 'to',
      quote: 'Price quotation',
      quote_disclaimer: 'The amount is indicative and does not include any additional services costs.',
      accept: 'I accept',
      privacy_label: 'the information on the processing of personal data',
      rules_label: 'port regulations',
      quote_message: 'The request will be forwarded to our offices and processed for verification. Once your request is accepted, you will receive a confirmation email.', // You can cancel your booking at any time following the instructions contained in it',
      accept_privacy_and_port_regulations: 'Pleace accept information on the processing of personal data and port regulations'
    }
  },
  fr: {
    booking_request: {
      save_and_continue: 'Sauvegarder et continuer',
      owner: 'Propriétaire',
      boat: 'Bateau',
      booking: 'réservation',
      summary: 'Résumé',
      request_sent: 'Demande envoyée',
      request_sent_message: 'Votre demande de réservation a été envoyée avec succès.',
      request_sent_description: 'Bientôt, vous recevrez un email avec le récapitulatif de votre demande.', // Si vous souhaitez effectuer la réservation, cliquez sur le lien dans l'email.",
      from: 'De',
      to: 'à',
      quote: 'Devis',
      quote_disclaimer: 'Le montant est donné à titre indicatif et n’inclut pas les coûts éventuels pour des prestations supplémentaires.',
      accept: 'J’accepte',
      privacy_label: 'les informations sur le traitement des données personnelles',
      rules_label: 'le règlement du port',
      quote_message: "La demande sera transférée vers nos bureaux et sera prise en charge afin d'être vérifiée. Si votre réservation est acceptée, vous recevrez un courriel de confirmation.", // Vous pourrez annuler votre réservation à tout moment en suivant les instructions mentionnées sur celle-ci.",
      send_request: 'Envoyer une demande',
      accept_privacy_and_port_regulations: "S'il vous plaît accepter les informations sur le traitement des données personnelles et le règlements du port"
    }
  },
  de: {
    booking_request: {
      save_and_continue: 'Speichern und fortfahren',
      owner: 'Inhaber',
      boat: 'Schiff',
      booking: 'Buchung',
      summary: 'Zusammenfassung',
      request_sent: 'Anfrage gesendet',
      request_sent_message: 'Ihre Anfrage wurde korrekt verschickt.',
      request_sent_description: 'Die Anfrage wird an unsere Büros zur Prüfung und Bearbeitung weitergeleitet, wird Ihr Antrag angenommen erhalten Sie eine E-Mail zur Bestätigung.', // Sei können Ihre Buchung jederzeit löschen, indem Sie den in ihr enthaltenen Anweisungen folgen.
      from: 'Von',
      to: 'an',
      quote: 'Kostenvoranschlag',
      quote_disclaimer: 'Der Betrag ist indikativ und beinhaltet keine zusätzlichen Servicekosten.',
      accept: 'Ich stimme',
      privacy_label: 'dem Infoblatt zur Verarbeitung der übermittelten personenbezogenen Daten zu',
      rules_label: 'der Hafenordnung zu',
      quote_message: 'Der Betrag ist nur ein Richtwert und schließt evtl. Kosten für Zusatzleistungen nicht ein.',
      send_request: 'Anfrage senden',
      accept_privacy_and_port_regulations: 'Bitte akzeptieren Sie die Datenschutz und Hafenbestimmungen'
    }
  }
}
